import axiosInstance from '../api';
import { notification } from 'antd';

// Get all plan
export const getAllPlan = async ({
  skip = 0,
  limit = 10,
  name = "",
  active = [],
  order = "desc",
  isCreditPlan = true,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    params.append("is_credit_plan", isCreditPlan);
    if (name) params.append("name", name);
    if (active.length) params.append("active", active.join(","));
    if (order) params.append("order", order);

    const response = await axiosInstance.get(`/subscription/?${params.toString()}`);
    if(response?.data?.status_code === 200){
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Subscription plan",
      description: response?.data?.message || "Failed to fetch Subscription plan list",
      duration: 3,
    });
    
  } catch (error) {
    console.log("error -->", error)
    notification.error({
      message: "Error Fetching Subscription plan",
      description: error.response?.data?.message || "Failed to fetch Subscription plan list",
      duration: 3,
    });
    throw new Error("Error fetching Subscription plan list");
  }
};

// update plan
export const updatePlan = async (updateId, updatedValues) => {
  try {
    const formData = new FormData();

    // Append primitive fields
    formData.append("plan_id", updateId);
    formData.append("name", updatedValues.name);
    formData.append("monthly_cost", updatedValues.monthly_cost);
    formData.append("yearly_cost", updatedValues.yearly_cost);
    formData.append("plan_description", updatedValues.plan_description);
    // formData.append("is_default_plan", updatedValues.is_default_plan);
    formData.append("is_enable", updatedValues.is_enable);

    // Handle badge image file
    if (updatedValues.badge instanceof File) {
      formData.append("badge", updatedValues.badge);
    }

    const response = await axiosInstance.put(
      `/subscription/plan_update_admin`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
      return false;
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error updating plan");
  }
};

// Get capped data for a specific plan
export const getCappedLimit = async (planId) => {
  try {
    const params = {
      plan_id: planId
    };
    const response = await axiosInstance.get(
      `/subscription/get_capped_data`, { params }
    );
    if (response?.data?.status_code === 200) {
      return response.data.data;
    }
    notification.error({
      message: "Fetch Error",
      description: response?.data?.message || "Failed to fetch capped limit.",
      duration: 3,
    });
    return null;
  } catch (error) {
    notification.error({
      message: "Fetch Error",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error("Error fetching capped limit");
  }
};

// Update capped usage for a specific plan
export const updateCappedLimit = async ({ id, ...values }) => {
  try {
    
    const response = await axiosInstance.put(
      `/subscription/update_capped_data`, { id, ...values }
    );
    // const response = await axiosInstance.put(`/subscription/update_capped_data/`, values);
    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "Unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error updating capped usage");
  }
};


// Get feature data for a specific plan
export const getFeatureData = async (planId, isCreditPlan = true) => {
  try {
    const response = await axiosInstance.get(`/subscription/get_feature_data`, {
      params: { plan_id: planId, is_credit_plan: isCreditPlan },
    });

    if (response.data.status_code === 200) {
      return response.data.data;
    }

    notification.error({
      message: "Feature Data Error",
      description: response.data.message || "Failed to fetch feature data.",
      duration: 3,
    });
    return null;
  } catch (error) {
    notification.error({
      message: "Feature Data Error",
      description: error.response?.data?.message || "Unexpected error occurred.",
      duration: 3,
    });
    throw new Error("Error fetching feature data");
  }
};

// Get all plan
export const getAllPaymentLog = async ({
  skip = 0,
  limit = 10,
  name = "",
  userId = "",
  costType = "",
  status = "",
  environment = "PRODUCTION",
  order = "desc",
  start_date = null,
  end_date = null,
  dateFieldType = "",
  isCreditPlan = true,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    params.append("is_credit_plan", isCreditPlan);
    if (name) params.append("name", name);
    if (order) params.append("order", order);
    if (userId) params.append("userId", userId);
    if (costType) params.append("cost_type", costType);
    if (status) params.append("status", status);
    if (environment) params.append("environment", environment);

    if(dateFieldType && start_date && end_date){
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      params.append("date_field_type", dateFieldType);
    } else if (start_date && end_date) {
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(`/subscription/paymentLog?${params.toString()}`);
    if(response?.data?.status_code === 200){
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Payment Log",
      description: response?.data?.message || "Failed to fetch Payment Log",
      duration: 3,
    });
    
  } catch (error) {
    console.log("error -->", error)
    notification.error({
      message: "Error Fetching Subscription plan",
      description: error.response?.data?.message || "Failed to fetch Payment Log",
      duration: 3,
    });
    throw new Error("Error fetching Payment Log");
  }
};

export const downloadLogs = async ({
  name = "",
  userId = "",
  status = "",
  costType = "",
  start_date = null,
  end_date = null,
  dateFieldType = "",
  order = "desc",
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (name) params.append("name", name);
    if (order) params.append("order", order);
    if (userId) params.append("userId", userId);
    if (costType) params.append("cost_type", costType);
    if (status) params.append("status", status);

    if(dateFieldType && start_date && end_date){
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      params.append("date_field_type", dateFieldType);
    }

    const response = await axiosInstance.get(`/subscription/log_download?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "payment_logs.csv"; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      return response; 
    } else {
      throw new Error("Download failed"); 
    }
  } catch (error) {
    console.error("Error downloading logs:", error);
    notification.error({
      message: "Error Downloading Logs",
      description: error.response?.data?.message || "Failed to download payment log list.",
      duration: 3,
    });
    throw error; 
  }
};


// get user plan
export const getUserPlan = async (user_id) => {
  try {
    const response = await axiosInstance.get(
      `/subscription/user_current_plan?user_id=${user_id}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Plan",
      description:
        response?.data?.message || "Failed to fetch Plan list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching plan",
      description:
        error.response?.data?.message || "Failed to fetch plan list.",
      duration: 3,
    });
    throw new Error("Error fetching plan list");
  }
};

export const updatePlanExpiry = async (userId, expiryDays, userSubscriptionId) => {
  const response = await axiosInstance.put(`/subscription/plan_expiry_update`, {
    user_id: userId,
    expiry_days: expiryDays,
    user_subscription_id: userSubscriptionId
  });

  if (response.data.status_code === 200) {
    return response.data.data;
  } else {
    throw new Error(response.data.message || "Failed to update expiry");
  }
};

export async function updatePlanCappedUsage(userId, subscriptionId, limitReset, limitValue, featureId) {
  try {
    const response = await axiosInstance.put(`/subscription/user_plan_capped_update`, {
      user_id:userId,
      user_subscription_id:subscriptionId,
      user_subscription_feature_id:featureId,
      limit_reset: limitReset,
      limit_value: limitValue,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function sendMassNotification({ title, body, url, recipientType, userIds = [], plan_type, tag_ids, campaign_title, feedback_enabled }) {
  try {
    const response = await axiosInstance.post(
      "/subscription/send_mass_notification",
      {
        title,
        body,
        url,
        recipientType,
        user_ids: Array.isArray(userIds) && userIds.length > 0 ? userIds : null,
        plan_type,
        tag_ids : Array.isArray(tag_ids) && tag_ids.length > 0 ? tag_ids : null,
        campaign_title: campaign_title || null,
        feedback_enabled: !!feedback_enabled,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function listMassNotification({
  skip = 0,
  limit = 10,
  mass_notification_content = "",
  user_id = "",
  plan_type = "",
  order = "desc",
  start_date = null,
  end_date = null,   
  audience_type = "",
  user_tag_id="",
}) {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (mass_notification_content) params.append("mass_notification_content", mass_notification_content);
    if (order) params.append("order", order);
    if (user_id) params.append("user_id", user_id);
    if (plan_type) params.append("plan_type", plan_type);
    if (audience_type) params.append("audience_type", audience_type);
    if (user_tag_id) params.append("user_tag_id", user_tag_id);

    if(start_date && end_date){
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(`/subscription/mass_notification_list?${params.toString()}`);
    if(response?.data?.status_code === 200){
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching mass notification ",
      description: response?.data?.message || "Failed to fetch Massnotification List",
      duration: 3,
    });
    
  } catch (error) {
    console.log("error -->", error)
    notification.error({
      message: "Error Fetching user log",
      description: error.response?.data?.message || "Failed to fetch Massnotification List",
      duration: 3,
    });
    throw new Error("Error fetching user Log");
  }
}

export async function listMassNotificationUsers({
  skip = 0,
  limit = 10,
  mass_notification_id = "",
}) {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (mass_notification_id) params.append("mass_notification_id", mass_notification_id);
    

    const response = await axiosInstance.get(`/subscription/get_mass_notification_users?${params.toString()}`);
    if(response?.data?.status_code === 200){
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching mass notification users ",
      description: response?.data?.message || "Failed to fetch Massnotification Users",
      duration: 3,
    });
    
  } catch (error) {
    console.log("error -->", error)
    notification.error({
      message: "Error Fetching mass notification users",
      description: error.response?.data?.message || "Failed to fetch Massnotification users",
      duration: 3,
    });
    throw new Error("Error fetching mass notification user");
  }
}

export const exportPaymentLogs = async ({
  name = "",
  userId = "",
  costType = "",
  status = "",
  environment = "PRODUCTION",
  order = "desc",
  start_date = null,
  end_date = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (order) params.append("order", order);
    if (name) params.append("name", name);
    if (userId) params.append("userId", userId);
    if (costType) params.append("cost_type", costType);
    if (status) params.append("status", status);
    if (environment) params.append("environment", environment);
    if (start_date && end_date) {
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(`/subscription/export_payment_log?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // extract filename from Content-Disposition header
      const disposition = response.headers["content-disposition"];
      let filename = "Payment_log.xlsx"; // fallback
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); // remove quotes if present
      }
      a.download = filename; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return response;
    } else {
      throw new Error("Download failed Payment log");
    }
  } catch (error) {
    console.error("Error downloading Payment log:", error);
    notification.error({
      message: "Error Downloading Payment Log",
      description: error.response?.data?.message || "Failed to download payment logs.",
      duration: 3,
    });
    throw error;
  }
};

export const exportUserPlanLogs = async ({
  name = "",
  userId = "",
  costType = "",
  order = "desc",
  start_date = null,
  end_date = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (order) params.append("order", order);
    if (name) params.append("name", name);
    if (userId) params.append("userId", userId);
    if (costType) params.append("cost_type", costType);
    if (start_date && end_date) {
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(`/subscription/export_userplan_log?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // extract filename from Content-Disposition header
      const disposition = response.headers["content-disposition"];
      let filename = "User_log.xlsx"; // fallback
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); // remove quotes if present
      }
      a.download = filename; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return response;
    } else {
      throw new Error("Download failed User log");
    }
  } catch (error) {
    console.error("Error downloading User log:", error);
    notification.error({
      message: "Error Downloading User Log",
      description: error.response?.data?.message || "Failed to download user logs.",
      duration: 3,
    });
    throw error;
  }
};

// Get all user logs
export const getAllUserPlanLog = async ({
  skip = 0,
  limit = 10,
  name = "",
  userId = "",
  costType = "",
  order = "desc",
  start_date = null,
  end_date = null,
  isCreditPlan = true,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    params.append("is_credit_plan", isCreditPlan);
    if (name) params.append("name", name);
    if (order) params.append("order", order);
    if (userId) params.append("userId", userId);
    if (costType) params.append("cost_type", costType);

    if(start_date && end_date){
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(`/subscription/userplan_log?${params.toString()}`);
    if(response?.data?.status_code === 200){
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching User Log",
      description: response?.data?.message || "Failed to fetch User Log",
      duration: 3,
    });
    
  } catch (error) {
    console.log("error -->", error)
    notification.error({
      message: "Error Fetching user log",
      description: error.response?.data?.message || "Failed to fetch user Log",
      duration: 3,
    });
    throw new Error("Error fetching user Log");
  }
};

export async function updateUserPlan(userId, subscriptionId, billing_cycle, user_subscription_id) {
  try {
    const response = await axiosInstance.put(`/subscription/update_user_plan`, {
      user_id:userId,
      subscription_id:subscriptionId,
      billing_cycle:billing_cycle,
      user_subscription_id // old
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export const downloadMassnotification = async ({
  mass_notification_content = "",
  user_id = "",
  plan_type = "",
  order = "desc",
  start_date = null,
  end_date = null,   
  audience_type = "",
  user_tag_id="",
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (mass_notification_content) params.append("mass_notification_content", mass_notification_content);
    if (order) params.append("order", order);
    if (user_id) params.append("user_id", user_id);
    if (plan_type) params.append("plan_type", plan_type);
    if (audience_type) params.append("audience_type", audience_type);
    if (user_tag_id) params.append("user_tag_id", user_tag_id);

    if(start_date && end_date){
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(`/subscription/export_mass_notification_list?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // extract filename from Content-Disposition header
      console.log(response.headers)
      const disposition = response.headers["content-disposition"];
      let filename = "Mass_notification.xlsx"; // fallback
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); // remove quotes if present
      }
      a.download = filename; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      return response; 
    } else {
      throw new Error("Download failed Mass notification"); 
    }
  } catch (error) {
    console.error("Error downloading MassNotification:", error);
    notification.error({
      message: "Error Downloading Mass notification",
      description: error.response?.data?.message || "Failed to download Mass notification.",
      duration: 3,
    });
    throw error; 
  }
};

export const downloadMassnotificationUsers = async ({
  mass_notification_id
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (mass_notification_id) params.append("mass_notification_id", mass_notification_id);

    
    const response = await axiosInstance.get(`/subscription/export_mass_notification_users?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // extract filename from Content-Disposition header
      console.log(response.headers)
      const disposition = response.headers["content-disposition"];
      let filename = "Mass_notification_users.xlsx"; // fallback
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); // remove quotes if present
      }
      a.download = filename; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      return response; 
    } else {
      throw new Error("Download failed Mass notification Users"); 
    }
  } catch (error) {
    console.error("Error downloading MassNotification Users:", error);
    notification.error({
      message: "Error Downloading Mass notification Users",
      description: error.response?.data?.message || "Failed to download Mass notification Users.",
      duration: 3,
    });
    throw error; 
  }
};